module.exports = __webpack_public_path__ + "assets/img/ic17.35054e69.gif";